import { Button } from 'antd';
import React from 'react';
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io'



const Pagination = ({ paginations, setPaginations, total }) => {

  const { pageSize, page } = paginations;
  const totalPages = Math.ceil(total / pageSize);

  // State to keep track of the current page
  // const [page, setPaginations] = useState(1);

  // Get the range of items for the current page
  const getPageRange = () => {
    const startIndex = (page - 1) * pageSize + 1;
    const endIndex = Math.min(page * pageSize, total);
    return { startIndex, endIndex };
  };

  // Get pagination info (e.g., 1-2/50)
  const getPaginationInfo = () => {
    const { startIndex, endIndex } = getPageRange();
    return `${startIndex}-${endIndex}/${total}`;
  };

  // Navigate to the next page with wrap-around
  const nextPage = () => {
    setPaginations({...paginations, page: page < totalPages ? page + 1 : 1});
  };

  // Navigate to the previous page with wrap-around
  const previousPage = () => {
    setPaginations({...paginations, page: page > 1 ? page - 1 : totalPages});
    // setPaginations(prevPage => (prevPage > 1 ? prevPage - 1 : totalPages));
  };

  // Go to a specific page
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setPaginations(page);
    }
  };
  return (
    <div>
      <div className='flex justify-end items-center overflow-x-auto'>
        <span className='text-sm me-2'>{getPaginationInfo()}</span>
        <Button type='text' size='small' disabled={pageSize > total ? true : false} onClick={previousPage} icon={<IoIosArrowBack />} />
        <Button type='text' size='small' disabled={pageSize > total ? true : false} onClick={nextPage} icon={<IoIosArrowForward />} />
      </div>
    </div>
  )
}

export default Pagination;